// extracted by mini-css-extract-plugin
export default {"news_d":"News_news_d__hRrk1","news_l":"News_news_l__E50xM"};